import { Inject } from '@odinjs/odin';

import {
  CONFIRMATION_FIELD_VALID,
  confirmationFieldValidator,
  Endpoint,
  FOUNDATION_ROUTES,
  passwordValidator,
  PWD_VALIDATOR,
  StipulatorConfigurationService,
} from '@philips-emr/hpms-stipulator-commons';
import { ButtonAPI, FieldAPI, FormAPI, ImageAPI, PanelAPI, TextAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnKeyDown, OnMount, OnValidate } from '@philips-emr/tws-core/lib/client';
import { ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { HttpError } from '@philips-emr/tws-core/lib/services/http-service';

import BaseController from '../BaseController';

@Controller({ fragment: 'new-password', component: 'layout-new-password' })
class NewPasswordControler extends BaseController {

  @Inject('panel-loader')
  private panelLoader: PanelAPI;

  @Inject('panel-actions')
  private panelActions: PanelAPI;

  @Inject('panel-success')
  private panelSuccess: PanelAPI;

  @Inject('panel-screen')
  private panelScreen: PanelAPI;

  @Inject('button-new-password')
  private buttonNewPassword: ButtonAPI;

  @Inject('form-new-password')
  private formNewPassword: FormAPI;

  @Inject('text-message')
  private textMessage: TextAPI;

  @Inject('field-new-password')
  private fieldNewPassword: FieldAPI;

  @Inject('field-confirm-password')
  private fieldConfirmPassword: FieldAPI;

  @OnMount({ target: 'image-new-password' })
  onMountLogo(event: MouseEvent): void {
    ThemeService.setContentTonalRange(StipulatorConfigurationService.getTonalidadeLogin());
    const api = event.target as unknown as ImageAPI;

    void StipulatorConfigurationService.getConfigurationData()
      .then(data => api.setSrc(data.dsUrlLogoHeaderLogin as string));
  }

  @OnValidate({ target: 'form-new-password' })
  onValidateForm(event: ValidateEvent): void {
    this.buttonNewPassword.setEnabled(event.valid);
  }

  @OnMount({ target: 'form-new-password' })
  onFormMount(): void {
    this.fieldConfirmPassword.addLocalValidator(CONFIRMATION_FIELD_VALID, (value) => {
      const confirmationValue = this.formNewPassword.getRecord()['newPassword'];
      return confirmationFieldValidator(value, confirmationValue);
    });
    this.fieldNewPassword.addLocalValidator(PWD_VALIDATOR, passwordValidator);
  }

  @OnKeyDown({ target: ['input-new-password', 'input-confirm-password'] })
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onClick();
    }
  }

  @OnClick({ target: 'button-new-password' })
  onClick(): void {
    if (this.formNewPassword.validate()) {
      this.panelLoader.setVisible(true);
      this.panelActions.setVisible(false);

      const { hash } = this.historyService.getCurrentRouteParams();

      const body = { ...this.formNewPassword.getRecord(), isUserConfirmation: this.isUserConfirmation() };

      HttpService.post(Endpoint.POST.NEW_PASSWORD, { hash }, { body })
        .then(() => {
          this.panelScreen.setVisible(false);
          this.panelSuccess.setVisible(true);
        })
        .catch(error => {
          this.panelLoader.setVisible(false);
          this.panelActions.setVisible(true);
          this.handleLoginError(error);
        });
    }
  }

  @OnClick({ target: 'button-ok' })
  onBtnClick(): void {
    this.historyService.push(FOUNDATION_ROUTES.LOGIN);
  }

  private handleLoginError(error: HttpError): void {
    if (error.response) {
      error.response.json()
        .then(() => this.textMessage.setValue('stipulator.falha'))
        .catch(() => this.textMessage.setValue('$expression.$1042711'));
    } else {
      this.textMessage.setValue('stipulator.falha');
    }
  }

  private isUserConfirmation(): boolean {
    const { path } = this.historyService.getMatch();
    return path.indexOf(FOUNDATION_ROUTES.CONFIRMAR_USUARIO_NOVA_SENHA) !== -1;
  }

}

export default NewPasswordControler;
